// fleet-generated: do not edit by hand
//
// Rendered from    : infra/fleet/artifacts/powersync/queries.tmpl.ts
// Parameters       : infra/fleet/registry/repos.ts  (entry "vigia-fleet-app")
// Destination      : packages/fleet/powersync/src/queries.ts
//
// TO CHANGE THIS FILE, edit the template or the registry entry in infra and
// re-render. Editing it here is reverted by the next render, and the guard
// in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo vigia-fleet-app
//     node fleet/fleet.ts check --repo vigia-fleet-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import { count, type PowerSyncDrizzleDB, sql } from "@vigia/powersync";

/**
 * Raw SQL query to get the number of pending changes in the PowerSync upload queue.
 * Used in Native where Drizzle might not be fully integrated for all components.
 */
export const UPLOAD_QUEUE_STATS_SQL = "SELECT count(*) as count FROM ps_crud" as const;

/**
 * Query to get the number of pending changes in the PowerSync upload queue.
 * Reused across Web and potentially Native (if using Drizzle).
 */
export function getUploadQueueStatsQuery(db: PowerSyncDrizzleDB) {
  return db.select({ count: count() }).from(sql`ps_crud`);
}
